import React, { useState, useEffect, Children } from "react";
import { EmployeeTeamVM } from '../../Models/ViewModels';
import { Table, Pagination, Stack, Avatar, Input, Button, Toggle } from "rsuite";
import * as TeamDB from '../../Services/EmployeeDB';
import { PageHeader } from "../../SharedComponents/PageHeader";

import { TeamDetailSimple } from "./TeamDetailSimple";
import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { CustomTableHeaderCell } from "../../SharedComponents/CustomTableHeaderCell";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
import { Modal } from "react-bootstrap";
import { TeamMembers } from "./TeamMembers";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";
import { GetTotalProcessBuffer } from "../../Services/KRAApprovalDB";
const { Column, HeaderCell, Cell,ColumnGroup } = Table;
const colors = ['pink', 'grey', 'blue', 'yellow', 'purple', 'green', 'red'];

export const ProcessBufferAlte = ({ name, designation, department }: any) => {
  const proc:any=[];
  const proc1:any=[];
  const [cachedTeamList, setCachedTeamList] = useState(new Array<EmployeeTeamVM>())
  const[processName,setProcessName]=useState(new Array<EmployeeTeamVM>())
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();
  const [isLoading, setLoading] = useState(true);
  const [page, setPage] = React.useState(1);
   const [limit, setLimit] = React.useState(15);
   const [filteredTeamList, setFilteredTeamList] = useState(new Array<EmployeeTeamVM>());
  const [checked,setChecked]=useState(false);
  const[loginid,setLoginid]=useState(GetUserLoginID())
  const[popup,setPopUp]=useState(false);
  const [teamMembers,setTeamMembers]=useState([])
  const[searching,setSearching]=useState(false);

  useEffect(() => {
     getAllTeamList(loginid);
  }, [])

  const handleClose = () => setPopUp(false);
  const filterData = (val:string,e: any) => {
    let searchText = val;
    setPage(1);
    if (searchText){
      setFilteredTeamList(cachedTeamList.filter(e => JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())))
      setSearching(true)
    }
    else{
      setFilteredTeamList([...cachedTeamList]);
      setSearching(false)
    }
      
  }

  const tableDataFeed = filteredTeamList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };


  const getFTEBuff = (processesArray: any[], processName: string) => {
    for(let i = 0; i < processesArray.length; i++) {
      if(processesArray[i].ProcessName === processName) {
        return processesArray[i].FTEBuff;
      }
    }
    return "";
  }
const getAllTeamList = (loginid:any) => {
    TeamDB.GetTeamDetails(loginid).then((res : EmployeeTeamVM[] | any) => {
      if (res) {   

        res = res.data;
        for (let i = 0; i < res.length; i++)
        {
       

          res[i].Total= ((+getFTEBuff(res[i].Processes, 'AR'))+
          (+getFTEBuff(res[i].Processes, 'ALL'))+
          (+getFTEBuff(res[i].Processes, 'Coding'))+
          (+getFTEBuff(res[i].Processes, 'Credentialing'))+
          (+getFTEBuff(res[i].Processes, 'PP'))+
          (+getFTEBuff(res[i].Processes, 'Demo'))+
          (+getFTEBuff(res[i].Processes, 'Denials'))+
          (+getFTEBuff(res[i].Processes, 'NA'))+
          (+getFTEBuff(res[i].Processes, 'Others'))+
          ( +getFTEBuff(res[i].Processes, 'CP'))+
          (+getFTEBuff(res[i].Processes, 'Statements'))+
          (+getFTEBuff(res[i].Processes, 'PFS')))*100
          
     
          res[i].ALLFTEBuffer=+getFTEBuff(res[i].Processes,'ALL');
          res[i].ARFTEBuffer = +getFTEBuff(res[i].Processes, 'AR');
          res[i].CodingFTEBuffer = +getFTEBuff(res[i].Processes, 'Coding');
          res[i].CPFTEBuffer = +getFTEBuff(res[i].Processes, 'CP');     
          res[i].DemoFTEBuffer = +getFTEBuff(res[i].Processes, 'Demo');
          res[i].DenialsFTEBuffer = +getFTEBuff(res[i].Processes, 'Denials');
          res[i].CredentialingFTEBuffer= +getFTEBuff(res[i].Processes, "Credentialing");
          res[i].NAFTEBuffer= +getFTEBuff(res[i].Processes, 'NA');
          res[i].OtherFTEBuffer= +getFTEBuff(res[i].Processes, 'Other');
          res[i].PFSFTEBuffer = +getFTEBuff(res[i].Processes, 'PFS'); 
          res[i].PPFTEBuffer = +getFTEBuff(res[i].Processes, 'PP');
          res[i].StatementsFTEBuffer= +getFTEBuff(res[i].Processes, 'Statements');
         }          
         setCachedTeamList(res)
         setFilteredTeamList(res);
         setLoading(false);
         
        }
    }).catch(err => {
      console.log(err)
    })

  }

  const handleSortColumn = (sortColumn: any, sortType: any) => {  
    setTimeout(() => {
    
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
    if (sortColumn && sortType) {
      return cachedTeamList.sort((a:any, b:any) => {
        let x = a[sortColumn] ;
        let y = b[sortColumn];
        if (typeof x === 'string' || '') {
          x = x.charCodeAt();
        }
        if (typeof y === 'string'||'') {
          y = y.charCodeAt();
        }
        if (sortType === 'asc') {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  }; 
  const handelDetailsPopUp=(rowData:any,loginid:any)=>{
    TeamDB.GetTeamMembersDetails(rowData.Team,loginid).then((res)=>{
      setTeamMembers(res.data)
      setPopUp(true)
    })
  }
  return <>
   
  <div>
    <Modal show={popup} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
        <Modal.Title>Team Members</Modal.Title>
        </Modal.Header>
        <Modal.Body>
             <TeamMembers members={teamMembers}/>           
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger" onClick={handleClose}>Close</button>
          <button className="btn btn-primary" onClick={()=>handleDownloadAsExcel(teamMembers)}>Export To Excel</button>
        </Modal.Footer>
        </Modal>
    <div className="show-container" >

     
      
     <Table
        id="table"  
        height={450}
        data={tableDataFeed}
        sortColumn={sortColumn}
        sortType={sortType}
        onSortColumn={handleSortColumn}
        loading={isLoading}
        bordered={true}
        cellBordered={true}
        className="border border-dark mt-2"
        // autoHeight={true}
        rowHeight={32}
        headerHeight={30}
        onRowClick={((rowData: any) => {
          handelDetailsPopUp(rowData,loginid);
        })}
      >
        <Column flexGrow={280}align="left" fixed sortable>
          <CustomTableHeaderCell >Team</CustomTableHeaderCell>
      
          <CustomTableCell>
          {(rowData: any) => {
                return (
                  <a href="#">{rowData.Team}</a>
                )
              }}
          </CustomTableCell>

        </Column>
        <Column flexGrow={70}  fixed >
          <CustomTableHeaderCell>ALL </CustomTableHeaderCell>
          <CustomTableCell >
          {(rowData: EmployeeTeamVM) => {
              return(
                    <div className="col-md-0">{rowData.ALLFTEBuffer*100}</div>
              )
            }
            }
            </CustomTableCell>
        </Column>
        <Column flexGrow={70}  fixed >
          <CustomTableHeaderCell>AR  </CustomTableHeaderCell>
          <CustomTableCell >
          {(rowData: EmployeeTeamVM) => {
              return(
                    <div className="col-md-0">{rowData.ARFTEBuffer*100}</div>
              )
            }
            }
            </CustomTableCell>
        </Column>
        <Column flexGrow={90}  fixed >
          <CustomTableHeaderCell>Coding  </CustomTableHeaderCell>
           <CustomTableCell >
           {(rowData: EmployeeTeamVM) => {
                return (
               
                    <div className="col-md-0 ">{rowData.CodingFTEBuffer*100}</div>
                 )
            }
            }
         
            </CustomTableCell>
        </Column>
        <Column flexGrow={70} fixed>
          <CustomTableHeaderCell>CP  </CustomTableHeaderCell>
          <CustomTableCell >
          {(rowData: EmployeeTeamVM) => {
                return (
       
                    <div className="col-md-0 ">{rowData.CPFTEBuffer*100}</div>
                )}}

            </CustomTableCell>
        </Column>

        <Column flexGrow={130} fixed>
          <CustomTableHeaderCell>Credentialing </CustomTableHeaderCell>
          <CustomTableCell >
          {(rowData: EmployeeTeamVM) => {
                return (
                    <div className="col-md-0 ">{rowData.CredentialingFTEBuffer*100}</div>
              )
            }
            }
            </CustomTableCell>
        </Column>

        <Column flexGrow={90}fixed >
          <CustomTableHeaderCell>Demo  </CustomTableHeaderCell>
          <CustomTableCell >
          {(rowData: EmployeeTeamVM) => {
                return (
                    <div className="col-md-0 ">{rowData.DemoFTEBuffer*100}</div>
              )
            }
            }
                </CustomTableCell>
        </Column>
        <Column flexGrow={80} fixed >
          <CustomTableHeaderCell>Denials </CustomTableHeaderCell>
          <CustomTableCell >
          {(rowData: EmployeeTeamVM) => {
                return (
                 
                    <div className="col-md-0 ">{rowData.DenialsFTEBuffer*100}</div>
                 
              )
            }
            }
         
         
            </CustomTableCell>
        </Column>
        

       
        <Column flexGrow={65}  fixed >
          <CustomTableHeaderCell>PFS  </CustomTableHeaderCell>
          <CustomTableCell >
          {(rowData: EmployeeTeamVM) => {
                return (     
                    <div className="col-md-0 ">{rowData.PFSFTEBuffer}</div>
              )
            }
            }
         
         
            </CustomTableCell>
        </Column>
        
        <Column flexGrow={60} fixed>
          <CustomTableHeaderCell>PP  </CustomTableHeaderCell>
          <CustomTableCell >
          {(rowData: EmployeeTeamVM) => {
                return (
                
                    <div className="col-md-0">{rowData.PPFTEBuffer*100}</div>
              )
            }
            }
         
         
            </CustomTableCell>
        </Column>

        <Column  width={100}  fixed >
          <CustomTableHeaderCell>Statements  </CustomTableHeaderCell>
          <CustomTableCell >
          {(rowData: EmployeeTeamVM) => {
                return (
                  
                    <div className="col-md-0 ">{rowData.StatementsFTEBuffer*100}</div>)
            }
            }
                  
            </CustomTableCell>
        </Column>
        <Column width={70}  fixed>
          <CustomTableHeaderCell>Other  </CustomTableHeaderCell>
          <CustomTableCell >
          {(rowData: EmployeeTeamVM) => {
                return (
                
                    <div className="col-md-0">{rowData.OtherFTEBuffer*100}</div>
              )
            }
            }
         
         
            </CustomTableCell>
        </Column>
        <Column width={60}  fixed>
          <CustomTableHeaderCell>NA  </CustomTableHeaderCell>
          <CustomTableCell >
          {(rowData: EmployeeTeamVM) => {
                return (
                
                    
                
                    <div className="col-md-0 ">{rowData.NAFTEBuffer*100}</div>
              )
            }
            }
              </CustomTableCell>
        </Column>

        <Column  width={100}   fixed >
          <CustomTableHeaderCell>Total </CustomTableHeaderCell>
          <CustomTableCell dataKey="Total"/>
        </Column>
       
      </Table>
       
      
      </div>


    </div>
    
  </>
}
